// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1iriL","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2fhWd","obliqueLine":"membershipbadge_obliqueLine__2fuHu"};